module.exports = __webpack_public_path__ + "media/images/Arrow-5688df0d44e935419243ba4a9897ab3f.svg";